import { render, staticRenderFns } from "./company-profile-page.vue?vue&type=template&id=2632193b"
import script from "./company-profile-page.vue?vue&type=script&lang=js"
export * from "./company-profile-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports